export default {
  versions: [
    { id: 'it', label: 'Italiano' },
    { id: 'es', label: 'Spagnolo' }
  ]
};
